import { __extends, __assign } from 'tslib';
import React__default from 'react';
import clsx from 'clsx';
import { Variants, propTypes, defaultProps } from './Skeleton.types.js';
import { getItemStyles, getItemKey } from './Skeleton.util.js';
import styles from './Skeleton.module.scss.js';

var Skeleton = /** @class */ (function (_super) {
    __extends(Skeleton, _super);
    function Skeleton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Skeleton.prototype.componentDidMount = function () {
        var _a = this.props, count = _a.count, variant = _a.variant, schema = _a.schema, schemaDirection = _a.schemaDirection, lineClassName = _a.lineClassName;
        var isSchema = !!(schema && schema.length);
        if (schemaDirection && !isSchema) {
            console.warn(' WARNING: schemaDirection work only with schema.');
        }
        if (isSchema && count > 1) {
            console.warn("\n                DANGER: count does not work with schema.\n                Send an array with the required element sizes.\n            ");
        }
        if (variant !== Variants.TEXT && count > 1 && !lineClassName) {
            console.warn("\n                DANGER: the first element will take up the entire container and the rest of the elements will not be visible.\n                Please use variant === \"text\" or schema or lineClassName to add a class with the required styles for all elements\n            ");
        }
    };
    Skeleton.prototype.render = function () {
        var _a = this.props, count = _a.count, color = _a.color, lineClassName = _a.lineClassName, className = _a.className, schemaDirection = _a.schemaDirection, variant = _a.variant, _b = _a.schema, schema = _b === void 0 ? [] : _b, propsTestId = _a["data-testid"], isLoading = _a.isLoading, children = _a.children, width = _a.width, height = _a.height, baseColor = _a.baseColor, highlightColor = _a.highlightColor, duration = _a.duration, style = _a.style, circle = _a.circle, direction = _a.direction, enableAnimation = _a.enableAnimation;
        if (!isLoading) {
            return children || null;
        }
        var testId = propsTestId || "Skeleton_" + variant;
        var stylesProperties = {
            direction: direction,
            enableAnimation: enableAnimation,
            duration: duration,
            style: style,
            color: color,
            baseColor: baseColor,
            highlightColor: highlightColor,
        };
        var isSchema = !!(schema && schema.length);
        var wrapperClassName = clsx(styles.Skeleton, className, !!(width && height) && styles.Skeleton___relative, isSchema && styles.Skeleton___schema, schemaDirection && styles["Skeleton___" + schemaDirection]);
        var itemClassName = clsx(styles.Skeleton_item, !isSchema && styles.Skeleton_item___default, isSchema && styles.Skeleton_item___schema, schemaDirection && styles["Skeleton_item___" + schemaDirection], styles["Skeleton_item___" + variant], circle && styles.Skeleton_item___circle, lineClassName);
        var items = new Array(count);
        if (isSchema) {
            items = schema.map(function (item) {
                var itemHeight = item.height, _a = item.style, itemStyle = _a === void 0 ? {} : _a, itemWidth = item.width, itemCircle = item.circle, schemaItemClassName = item.className;
                var compiledStyle = Object.assign(getItemStyles(stylesProperties), itemStyle, itemWidth && { width: itemWidth }, itemHeight && { height: itemHeight });
                return {
                    className: clsx(schemaItemClassName, itemCircle && styles.Skeleton_item___circle, itemClassName),
                    'data-testid': testId + "_item",
                    style: compiledStyle,
                };
            });
        }
        else {
            items.fill({
                className: itemClassName,
                'data-testid': testId + "_item",
                style: getItemStyles(stylesProperties),
            });
        }
        return (React__default.createElement("div", { className: wrapperClassName, "data-testid": testId, style: { width: width, height: height }, "aria-live": this.props['aria-live'], "aria-busy": this.props['aria-busy'] }, items.map(function (item, i) { return (React__default.createElement("div", __assign({ key: getItemKey(i) }, item))); })));
    };
    Skeleton.propTypes = propTypes;
    Skeleton.defaultProps = __assign({}, defaultProps);
    Skeleton.displayName = 'Skeleton';
    return Skeleton;
}(React__default.Component));

export { Skeleton, Skeleton as default };
